<div role="alert" aria-live="polite" aria-atomic="true" class="peca-retry --is-{{ type }}">
  <div class="peca-retry__content">
    <h2>
      <span class="icon">{{ icon }}</span>
      <span>{{ title }}</span>
    </h2>
    <p><ng-content /></p>
  </div>
</div>
